import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface DetailSectionProps {
	title: ReactNode
	icon: LucideIcon
	/** Optional control rendered at the trailing edge of the header bar. */
	action?: ReactNode
	children: ReactNode
}

/**
 * A titled section inside a detail page: the title on a thin rule, content below.
 * No filled bar: the title reads on the page background, in the text colour.
 * Presentational only — data-aware callers render their own loading, error,
 * and empty states as children.
 */
function DetailSection({
	title,
	icon: Icon,
	action,
	children
}: DetailSectionProps) {
	return (
		<section className='flex flex-col'>
			<header className='flex min-h-9 items-center gap-2 border-border border-b pb-3'>
				<Icon aria-hidden className='size-4 text-muted-foreground' />
				<h3 className='font-semibold text-[15px] text-foreground'>
					{title}
				</h3>
				{action ? <div className='ml-auto'>{action}</div> : null}
			</header>
			<div className='pt-5'>{children}</div>
		</section>
	)
}

export { DetailSection }
